import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DialogComponent, Spinner } from '../../../../../../Components';
import { showError, showSuccess } from '../../../../../../Helper';
import { DeleteVendorService } from '../../../../../../Services';
import { VendorsTranslationPath } from '../../../I18n/VendorsLocale';

const parentTranslationPath = 'UnitsView';
const DeleteServiceDialog = ({
  title,
  open,
  onClose,
  onSave,
  activeItem,
  itemName,
}) => {
  const { t } = useTranslation(VendorsTranslationPath);
  const [isLoading, setIsLoading] = useState(false);

  const deleteHandler = async () => {
    try {
      setIsLoading(true);
      if (activeItem) {
        await DeleteVendorService(activeItem?.vendorServiceId);
      }
      await onSave();
      onClose();
      showSuccess(t(`delete_successfully`));
    } catch (error) {
      showError(t(`delete_failed`));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogComponent
      titleText={title ?? t(`delete_service`)}
      saveText={t('confirm', { ns: parentTranslationPath })}
      saveType='button'
      maxWidth='sm'
      dialogContent={
        <div className='d-flex-column-center'>
          <Spinner isActive={isLoading} />
          <span className='mdi mdi-close-octagon c-danger mdi-48px' />
          <div className='w-100' style={{ display: 'block' }}>
            {' '}
            <span>
              {`${t('Are-you-sure-you-want-to-Delete', {
                ns: parentTranslationPath,
              })}`}{' '}
              :
            </span>{' '}
            <div style={{ fontWeight: 600, width: '130px' }}>
              <p
                style={{
                  fontWeight: 600,
                  width: '30rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {itemName ?? activeItem?.serviceType}
              </p>
            </div>
          </div>
        </div>
      }
      saveClasses='btns theme-solid bg-danger w-100 mx-2 mb-2'
      isOpen={open}
      onSaveClicked={deleteHandler}
      onCloseClicked={onClose}
      onCancelClicked={onClose}
    />
  );
};

DeleteServiceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  activeItem: PropTypes.instanceOf(Object).isRequired,
};

export default DeleteServiceDialog;
